module.exports = __webpack_public_path__ + "a47b9e2c4ae271666414500a16e9de69.png";